import PropTypes from 'prop-types';
import { Form } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import MLink from '@material-ui/core/Link';
import * as Yup from 'yup';
import consumeAppContext from '../../consumers/app';
import TextAreaField from '../forms/text-area-field';
import MaterialLink from '../material-link';
import FormSubmitStatus from '../forms/form-submit-status';
import FormikPersist from '../../utils/formik-persist';

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    alignItems: 'center'
  },
  submitButton: {
    marginRight: theme.spacing(2)
  },
  postingAs: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    width: 20,
    height: 20,
    margin: theme.spacing(0, 0.5, 0, 0.5)
  }
}));

export const newCommentSchema = Yup.object().shape({
  body: Yup.string().nullable().required('Message is required')
});

const NewEventCommentForm = (props) => {
  const { isSubmitting, submitCount, disabled: formDisabled, loggedInUser, name } = props;
  const classes = useStyles();
  const disabled = isSubmitting || formDisabled;
  const errorsDisabled = submitCount < 1;
  return (
    <Form>
      <TextAreaField
        name="body"
        label="Add a comment"
        disabled={disabled}
        errorsDisabled={errorsDisabled}
        helperText={(
          <span>
            <MLink href="https://www.markdownguide.org/basic-syntax/" target="_blank">
              Markdown
            </MLink>
            {' '}is supported
          </span>
        )}
      />

      <div className={classes.buttons}>
        <Button
          type="submit"
          margin="normal"
          disabled={disabled}
          variant="contained"
          color="primary"
          className={classes.submitButton}
        >
          Post
        </Button>
        {loggedInUser && (
          <div className={classes.postingAs}>
            Commenting as
            {' '}
            <Avatar
              alt={loggedInUser.displayName}
              src={loggedInUser.avatar.small.url}
              className={classes.avatar}
            />
            <MaterialLink href="/people/[username]" as={`/people/${loggedInUser.username}`}>
              {loggedInUser.displayName}
            </MaterialLink>
          </div>
        )}
        <FormSubmitStatus {...props} />
      </div>
      <FormikPersist name={name} />
    </Form>
  );
};

NewEventCommentForm.propTypes = {
  submitCount: PropTypes.number,
  isSubmitting: PropTypes.bool,
  disabled: PropTypes.bool,
  loggedInUser: PropTypes.object,
  name: PropTypes.string
};

export default consumeAppContext(NewEventCommentForm);
